import h from 'hyperscript';
import { importModule } from 'disy';
import logger from 'cadenza/utils/logging';
import ConditionAction from './condition-action';
import icon from 'cadenza/utils/icon';
import playIcon from 'cadenza/icons/play.svg';
import { default as i18n } from 'cadenza/utils/i18n';

export default class Animate extends ConditionAction {

  _isSupportedSync () {
    return true;
  }

  execute () {
    return importModule('time-slider-player').then((TimeSliderPlayer) => {
      return new Promise((resolve, reject) => {
        const timeSliderPlayer = new TimeSliderPlayer(this._selectorId, this._conditionName, this._mapElement);
        timeSliderPlayer.onclose = () => {
          resolve(timeSliderPlayer.finalValue);
          timeSliderPlayer.remove();
        };
        document.body.appendChild(timeSliderPlayer);
        timeSliderPlayer.showModal();
      });
    }).fail(error => logger.warn('Could not animate', error));
  }

  static createAnimateButton (selectorId, conditionName, mapElement) {
    const animateAction = new Animate(selectorId, conditionName, mapElement, {});

    return h('button.button.button-link.button-small.button-animate', {
      'type': 'button',
      'aria-pressed': 'false',
      'title': i18n('time.slider.animation'),
      'onclick': () => { animateAction.execute(); }
    }, [icon(playIcon), i18n('time.slider.animation')]);
  }

}
